/**
 * Returns a value from an object by a JSON pointer according to https://datatracker.ietf.org/doc/html/rfc6901
 * However, I didn't bother implementing arrays. So this only does field lookup by name
 * @param obj The object to point at
 * @param pointer The path to point to
 * @returns The object at that path, or null if not found
 */
function getByJsonPointer<T>(
  obj: Record<string, unknown>,
  pointer: string
): T | null {
  if (!pointer.startsWith('/')) {
    return null;
  }

  if (pointer === '/') {
    return obj as T;
  }

  const keys = pointer.split('/');
  let result: unknown = obj;
  for (const key of keys) {
    if (
      typeof result !== 'object' ||
      result === null ||
      Array.isArray(result)
    ) {
      return null;
    }

    if (key) {
      result = (result as Record<string, unknown>)?.[key];
    }
  }

  return result as T;
}

export { getByJsonPointer };
